export const DEFAULT_SPEAKERS_COUNT = 2;

export const speakersCountOptions = [2, 3, 4, 5].map((value) => ({
  value,
  name: `${value} speakers`,
}));

export const getSpeakersCountDisplay = (value) => {
  const option = speakersCountOptions.find((item) => item.value === value);
  return option ? option.name : `${value} speakers`;
};
